module.exports = __webpack_public_path__ + "img/tuxedo.e687139f.jpg";